module.exports = __webpack_public_path__ + "img/dingdingIcon.97177583.png";